import LoginForm from '../../components/login/LoginForm'
import FormLayout from '../../layouts/FormLayout'

const LoginScreen = () => {
  return (
    <FormLayout bg="white">
      <LoginForm />
    </FormLayout>
  )
}

export default LoginScreen
